// base class to render routes on the map, which can be extended to render all types of routes like point to point, snap to road, directions service etc.

import { TRenderRouteClassParams } from "./type";

const debug = false;

export class RenderRoute<TSanitizedTripPoints = any> {
  props: TRenderRouteClassParams<TSanitizedTripPoints>["props"];
  tripIndex: TRenderRouteClassParams<TSanitizedTripPoints>["tripIndex"];
  sanitizedTripPoints: TRenderRouteClassParams<TSanitizedTripPoints>["sanitizedTripPoints"];
  interpolatedTripPoints: TRenderRouteClassParams<TSanitizedTripPoints>["interpolatedTripPoints"];
  polylineConfig: TRenderRouteClassParams<TSanitizedTripPoints>["polylineConfig"];

  mapElements: any;
  isError: boolean = false;
  isInitialized: boolean = false;

  refString: string = ""; // optional string to identify the instance in debug logs

  // constructor initializes the properties from a single params object
  constructor(params: TRenderRouteClassParams<TSanitizedTripPoints>) {
    const {
      props,
      tripIndex,
      sanitizedTripPoints,
      interpolatedTripPoints = null,
      polylineConfig,
      refString = "",
    } = params;
    this.props = props;
    this.tripIndex = tripIndex;
    this.sanitizedTripPoints = sanitizedTripPoints;
    this.interpolatedTripPoints = interpolatedTripPoints;
    this.polylineConfig = polylineConfig;
    this.refString = refString;
  }

  setMapElements = (mapElements: any) => {
    this.mapElements = mapElements;
    // store the map elements in mapRef for future reference (like hide/show)
    this.props.mapRef.current.objects.mTripsData[
      this.tripIndex
    ].views.ROUTE_POINT_TO_POINT.mapElements = mapElements;
  };

  getMapElements = () => {
    return this.mapElements;
  };

  show = () => {
    const { props, tripIndex } = this;
    const map = props.mapRef.current.map;
    // show the route on the map using the mapElements stored in mapRef
    const routeMapElement =
      props.mapRef.current.objects.mTripsData[tripIndex].views
        .ROUTE_POINT_TO_POINT.mapElements;
    if (debug) {
      console.log("[show] this", this);
      console.log("[show] routeMapElement", routeMapElement);
    }
    // if (routeMapElement) {
    //   routeMapElement.setMap(map);
    // } else {
    //   // if map element is not found, it means there was an error in rendering the route, so we can try rendering the route again
    //   this.render();
    // }
    this.mapElements?.forEach((element: any) => {
      element.setMap(map);
    });
    // update mTripsVisibility
    props.mapRef.current.objects.mTripsVisibility[tripIndex] = 1;
  };

  hide = () => {
    const { props, tripIndex } = this;
    // hide the route on the map using the mapElements stored in mapRef
    const routeMapElement =
      props.mapRef.current.objects.mTripsData[tripIndex].views
        .ROUTE_POINT_TO_POINT.mapElements;
    if (debug) {
      console.log("[hide] this", this);
      console.log("[hide] routeMapElement", routeMapElement);
    }
    // if (routeMapElement) {
    //   routeMapElement.setMap(null);
    // }
    this.mapElements?.forEach((element: any) => {
      element.setMap(null);
    });
    // update mTripsVisibility
    props.mapRef.current.objects.mTripsVisibility[tripIndex] = 0;
  };
}
